import {
    FETCH_PARKED_VISITS_ERROR, FETCH_PARKED_VISITS_START, FETCH_PARKED_VISITS_SUCCESS, SET_PARKED_SEARCH_FILTER_AND_SORT, SET_PARKED_VISIT_PAGINATION,
    VIEW_PARKED_VISIT_START, VIEW_PARKED_VISIT_SUCCESS, VIEW_PARKED_VISIT_ERROR, RESET_TYPIST_PARKED_FILTER, SET_PARKED_AUTO_NEXT_VISIT
} from '../../actions/typist/typistParkedAction';
import { paginationSize } from '../../../constants/constants';
import _ from 'lodash';

const INIT_STATE = {
    error: "",
    loading: false,
    unlocking: false,
    message: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    visits: [],
    searchFilter: {
        searchText: "",
        mipIds: [],
        modalityIds: [],
        risId: 1,
        startDate: null,
        endDate: null,
    },
    sortConditions: [{ sortBy: "visitStart", dataType: "DATE", sortType: "desc" }],
    skippedVisits: [],
    autoNextVisit: false

};

const typistParkedReducer = (state = INIT_STATE, action) => {
    let newVisits;
    let index;
    switch (action.type) {
        case SET_PARKED_SEARCH_FILTER_AND_SORT: {
            return {
                ...state,
                searchFilter: { ...state.searchFilter, ...action.payload.searchFilter },
                sortConditions: action.payload.sortConditions.length > 0 ? [...action.payload.sortConditions] : [],
                skippedVisits: action.payload.skippedVisits.length > 0 ? [...action.payload.skippedVisits] : []
            }
        }
        case FETCH_PARKED_VISITS_START: {
            return { ...state, error: '', message: '', found: false, loading: true };
        }
        case FETCH_PARKED_VISITS_SUCCESS: {
            return { ...state, error: '', message: '', found: false, loading: false, visits: action.visits };
        }
        case FETCH_PARKED_VISITS_ERROR: {
            return { ...state, error: '', message: '', found: false, loading: false };
        }
        case SET_PARKED_VISIT_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }
        case VIEW_PARKED_VISIT_START: {
            return { ...state, loading: true };
        }
        case VIEW_PARKED_VISIT_SUCCESS: {
            return { ...state, loading: false };
        }
        case VIEW_PARKED_VISIT_ERROR: {
            return { ...state, loading: false };
        }
        case RESET_TYPIST_PARKED_FILTER: {
            let newState = _.cloneDeep(state);
            newState.searchFilter.searchText = null;
            newState.searchFilter.startDate = null;
            newState.searchFilter.endDate = null;
            return { ...newState };
        }
        case SET_PARKED_AUTO_NEXT_VISIT: {
            return { ...state, autoNextVisit: action.autoNextVisit };
        }
        default:
            return state;
    }
}

export default typistParkedReducer;
